import {$} from '../util/jq';
import changePageClass from './_changePageClass';
import 'url-search-params-polyfill';

const bottomLineFieldsMap = [
  {
    field: 'appRequest.primary.firstName',
    paramName: 'firstName'
  },
  {
    field: 'appRequest.primary.lastName',
    paramName: 'lastName'
  },
  {
    field: 'appRequest.primary.emailAddress',
    paramName: 'email'
  },
  {
    field: 'appRequest.primary.phone.homePhoneNumber',
    paramName: 'phone'
  },
  {
    field: 'appRequest.market.name',
    paramName: 'market'
  }
];

const debugLog = (environment, logMsg, logData) => {
  if(environment === 'development' || environment === 'staging'){
    console.log(logMsg, logData);
    debugger;
  }
};

const sendToBottomLine = () => {
  const searchParams = new URLSearchParams((window.location.hash).replace('#', ''));
  const environment = searchParams.has('environment') ? searchParams.get('environment') : 'development';
  const jeffersonMarketId = '02';
  const bankCentralMarketId = '45';
  const market = searchParams.get('market');
  const product = searchParams.get('prod');

  //determine API URL
  const jeffersonMarketUrl   = 'https://apply.jefferson-bank.com';
  const bankCentralMarketUrl = 'https://apply.bankcentral.net';
  const centralMarketUrl     = 'https://apply.centralbank.net';
  const environmentUrls = {
    PRODUCTION:    market === jeffersonMarketId
      ? jeffersonMarketUrl
      : market === bankCentralMarketId
        ? bankCentralMarketUrl
        : centralMarketUrl,
    DEVELOPMENT:   'https://cbc-web.oflows.us'
  };
  const bottomLineURI = environment === "production" ? environmentUrls.PRODUCTION : environmentUrls.DEVELOPMENT;

  //prepare API data
  const data = {
    product: product,
    market: market,
    prefill: {}
  };
  bottomLineFieldsMap.map(function(mapping){
    if(searchParams.has(mapping.paramName)){
      data.prefill[mapping.field] = searchParams.get(mapping.paramName);
    }
  });

  debugLog(environment, 'Data to send', data);

  //Send data to OAO
  $.ajax({
    url: `${bottomLineURI}/oflows/api/oao/workflow/prefill`,
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    xhrFields: {
      withCredentials: true
    },
    data: JSON.stringify(data),
    success : function(response) {
      if (response.msg || (response.result && response.result.status === false)) {
        //if a prefill error occurs, we should still redirect user to OAO
        debugLog(environment, 'Unable to prefill', response);
        window.location.replace(`${bottomLineURI}/oao/?product=${product}&market=${market}`);
      } else {
        const _sid = response && response.meta && response.meta.tokens ? response.meta.tokens.sid : '';
        const _prefillToken = response && response.meta && response.meta.tokens ? response.meta.tokens.prefillToken : '';
        // session cookie
        const date = new Date();
        date.setTime(date.getTime() + (24*60*60*1000));
        const expires = "; expires=" + date.toUTCString();
        window.location.replace(`${bottomLineURI}/oao/primaryinfo?product=${product}&market=${market}&prefillToken=${_prefillToken}`);
      }
    },
    error: function(response) {
      //if a prefill error occurs, we should still redirect user to OAO
      debugLog(environment, 'Prefill API call failed', response);
      window.location.replace(`${bottomLineURI}/oao/?product=${product}&market=${market}`);
    }
  });

};

export default function bottomLinePage() {
  changePageClass('bottomLine');
  $('html').removeClass('wf-loading');
  sendToBottomLine();
}



// WEBPACK FOOTER //
// ./src/main/js/pages/bottomLinePage.js